import '../@types.js';

import { ILogger } from '@remento/logger';
import { Debugger } from '@remento/web-analytics-router/debugger';
import { Payload, Router } from '@remento/web-analytics-router/router';
import { EmailFormSubmitEvent, EmailFormSubmitPayload } from '@remento/web-analytics-router/sources/form/@types';

function extractFormPayload(logger: ILogger, $formTarget: HTMLFormElement): Payload<EmailFormSubmitPayload> | null {
  const $emailInput = $formTarget.querySelector('[name="email"]') as HTMLInputElement;
  const $phoneNumberInput = $formTarget.querySelector('[name="phone-number"]') as HTMLInputElement;
  const $phoneCodeInput = $formTarget.querySelector('[name="phone-dialcode"]') as HTMLInputElement;
  if ($emailInput == null && $phoneNumberInput == null) {
    logger.error('WISEPOP_FORM_SUBMITTED', () => ({ error: 'NO_IDENTIFIER_INPUT' }));
    return null;
  }
  // Wisepops splits the submissions of its form in a popop but requires unique field names
  const $formType = ($formTarget.querySelector('[name="formType"]') ??
    $formTarget.querySelector('[name="emailFormType"]') ??
    $formTarget.querySelector('[name="phoneFormType"]')) as HTMLInputElement;
  const $formListId = ($formTarget.querySelector('[name="formListId"]') ??
    $formTarget.querySelector('[name="emailFormListId"]') ??
    $formTarget.querySelector('[name="phoneFormListId"]')) as HTMLInputElement;

  return {
    data: {
      email: $emailInput?.value ?? undefined,
      phone:
        $phoneNumberInput != null
          ? $phoneCodeInput != null
            ? $phoneCodeInput.value + ' ' + $phoneNumberInput.value
            : $phoneNumberInput.value
          : undefined,
      formType: $formTarget.dataset.analyticsType ?? $formType?.value ?? 'unknown',
      formListId: $formTarget.dataset.analyticsListId ?? $formListId?.value ?? undefined,
    },
    properties: {},
  };
}

export function registerWisepopsEmailFormsObserver(router: Router, debug: Debugger | null) {
  if (!router.registerPublisher('email-form-wisepops-observer')) {
    return;
  }
  const logger = router.logger.extend('form-observer-wisepops');
  window.wisepops('listen', 'after-form-submit', function (event) {
    const $formTarget = event.target as HTMLFormElement;
    const payload = extractFormPayload(logger, $formTarget);
    if (payload == null) {
      return;
    }
    logger.debug(`WISEPOP_FORM_SUBMITTED`, () => ({ payload: event.detail }));
    router.publish(EmailFormSubmitEvent, {
      ...payload,
      properties: { wpDialogId: event.detail.popup.id, wpCampaignId: event.detail.popup.campaignId },
    });
  });

  // if (debug != null) {
  //   let debugMutationObserver: MutationObserver | null = null;
  //   // The debug tool tips have to be rendered dynamically since wisepops does not necessarily display the form upfron
  //   window.wisepops('listen', 'before-popup-display', function (event) {
  //     const renderTooltip = () => {
  //       const element = event.target.querySelector('form button');
  //       if (element == null) {
  //         console.log('Not found');
  //         return;
  //       }
  //       debug?.initTooltip(element as HTMLElement, ($element) => {
  //         const $form = $element.closest('form');
  //         const payload = $form == null ? null : extractFormPayload(logger, $form);
  //         return { type: 'website.form', payload, identify: undefined };
  //       });
  //     };
  //     const $dialog = event.detail.target;
  //     debugMutationObserver = new MutationObserver(renderTooltip);
  //     debugMutationObserver.observe($dialog, { subtree: true, childList: true });
  //     renderTooltip();
  //     $dialog.style.zIndex = '1000';
  //     $dialog.parentElement!.style.zIndex = '1000';
  //   });
  //   window.wisepops('listen', 'after-popup-close', function (event) {
  //     if (debugMutationObserver != null) {
  //       debugMutationObserver.disconnect();
  //     }
  //   });
  // }
}
